// import {
//   AuthService,
//   getClientSettings,
// } from "./../../shared/services/auth.service";
import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn,
} from "@angular/router";
import { AuthService } from "@shared/services/auth.service";
import { GibService } from "../../shared/services/gib.service";
// import { User } from "oidc-client";

// CanActivateFn
// Path: src/app/core/services/auth-guard.service.ts

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  // return true
  const router = inject(Router);
  const authService = inject(AuthService);
  const gibService = inject(GibService);

  if (authService.accessToken && authService.isAuthenticated()) {
    return true;
  }
  else {
    router.navigate(['welcome']);
    gibService.setGuest();
    return false;
  }
  // return new Promise<boolean>((resolve, reject) => {
  //   const clientSettings = getClientSettings();
  //   const key = `oidc.user:${clientSettings.authority}:${clientSettings.client_id}`;
  //   const jwtToken = sessionStorage.getItem(key);
  //   if (jwtToken) {
  //     const userFromToken = User.fromStorageString(jwtToken);
  //     // expired cases
  //     if (userFromToken.expired) {
  //       localStorage.setItem("redirect_url", state.url);
  //       authService.signIn();
  //       resolve(false);
  //     }
  //     // end expired cases
  //     authService.setUserFromStorage(userFromToken).then((user) => {
  //       return authService
  //         .setUserClaimsPermissionsAndMenuPromise(user)
  //         .then((permissions) => {
  //           resolve(true);
  //         })
  //         .catch((error) => {
  //           // router.navigate(['../error-page/error-401'], {queryParams: {error}});
  //           // reject();
  //           resolve(true);
  //         });
  //     });
  //   } else {
  //     localStorage.setItem("redirect_url", state.url);
  //     authService.signIn();
  //     return false;
  //   }
  // });
};
